/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Elastic_Gallery_Item_01_CategoryInputs */

const en_elastic_gallery_item_01_category = /** @type {(inputs: Elastic_Gallery_Item_01_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Photography`)
};

const ar_elastic_gallery_item_01_category = /** @type {(inputs: Elastic_Gallery_Item_01_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تصوير`)
};

const bn_elastic_gallery_item_01_category = /** @type {(inputs: Elastic_Gallery_Item_01_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ফটোগ্রাফি`)
};

const de_elastic_gallery_item_01_category = /** @type {(inputs: Elastic_Gallery_Item_01_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fotografie`)
};

const es_elastic_gallery_item_01_category = /** @type {(inputs: Elastic_Gallery_Item_01_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fotografía`)
};

const fr_elastic_gallery_item_01_category = /** @type {(inputs: Elastic_Gallery_Item_01_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Photographie`)
};

const pt_elastic_gallery_item_01_category = /** @type {(inputs: Elastic_Gallery_Item_01_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fotografia`)
};

const zh_elastic_gallery_item_01_category = /** @type {(inputs: Elastic_Gallery_Item_01_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`摄影`)
};

const tr_elastic_gallery_item_01_category = /** @type {(inputs: Elastic_Gallery_Item_01_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fotoğrafçılık`)
};

const ru_elastic_gallery_item_01_category = /** @type {(inputs: Elastic_Gallery_Item_01_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Фотография`)
};

const pl_elastic_gallery_item_01_category = /** @type {(inputs: Elastic_Gallery_Item_01_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fotografia`)
};

/**
* | output |
* | --- |
* | "Photography" |
*
* @param {Elastic_Gallery_Item_01_CategoryInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const elastic_gallery_item_01_category = /** @type {((inputs?: Elastic_Gallery_Item_01_CategoryInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Elastic_Gallery_Item_01_CategoryInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_elastic_gallery_item_01_category(inputs)
	if (locale === "bn") return bn_elastic_gallery_item_01_category(inputs)
	if (locale === "de") return de_elastic_gallery_item_01_category(inputs)
	if (locale === "es") return es_elastic_gallery_item_01_category(inputs)
	if (locale === "fr") return fr_elastic_gallery_item_01_category(inputs)
	if (locale === "pt") return pt_elastic_gallery_item_01_category(inputs)
	if (locale === "zh") return zh_elastic_gallery_item_01_category(inputs)
	if (locale === "tr") return tr_elastic_gallery_item_01_category(inputs)
	if (locale === "ru") return ru_elastic_gallery_item_01_category(inputs)
	if (locale === "pl") return pl_elastic_gallery_item_01_category(inputs)
	return en_elastic_gallery_item_01_category(inputs)
});